import PushTable from './PushTable';

export default PushTable;
